export default __webpack_public_path__ + "static/media/awakening-737x1024.9bb33c3f.png";